import axios from '../service/axios/axios';

export default {
    //患者信息列表
    patientList(data) {
        return axios({
            method: 'post',
            url: 'platform/patient/patientList',
            data: data
        });
    },
    // 设置测试用户
    setTestUser({ user_id, status }) {
        return axios({
            method: 'post',
            url: 'platform/patient/setTestUser',
            data: { user_id, status }
        });
    },
    //用户详情【用户信息】
    userItem({ user_id }) {
        return axios({
            method: 'post',
            url: 'platform/patient/userItem',
            data: { user_id }
        });
    },
    //用户详情【用户信息】
    userPatientList(data) {
        return axios({
            method: 'post',
            url: 'platform/patient/userPatientList',
            data: data
        });
    },
    //患者详情【患者信息】
    patientItem({ patient_id }) {
        return axios({
            method: 'post',
            url: 'platform/patient/patientItem',
            data: { patient_id }
        });
    },
    // 成为星推官
    joinCommissionStar(data) {
        return axios({
            method: 'post',
            url: 'platform/StarSalesman/joinCommissionStar',
            data: data
        });
    },
    // 取消星推官
    cancelCommissionStar(data) {
        return axios({
            method: 'post',
            url: 'platform/StarSalesman/cancelCommissionStar',
            data: data
        });
    },
}